import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {AppState, ShipmentTypes} from '@store/reducers';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {DateFormatPipe} from '@pipes/date-format.pipe';
import {CurrencyFormatPipe} from '@pipes/currency-fomat.pipe';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-ongoing-shipments',
  template: `
    <app-shipment-table *ngIf="shipmentsState"
      [shipmentType]="shipmentTypes.ONGOING"
      [rows]="rows"
      [data]="generateData(data)"
      [checkboxSign]="false"
      [deleteSign]="false"
      [totalShipmentsLength]="totalShipmentsLength"
      [currentPageSize]="currentPageSize"
      [currentPage]="currentPage"
      (selectRow)="handleSelectRow($event)"
      (changePage)="handleChangePage($event)"></app-shipment-table>
  `,
  styleUrls: ['./ongoing-shipments.component.scss']
})
export class OngoingShipmentsComponent {
  shipmentTypes = ShipmentTypes;
  rows = [
    {label: this.translate.instant('account.section.shipment.ongoing.table.header1'), value: 'consignment_no'},
    {label: this.translate.instant('account.section.shipment.ongoing.table.header2'), value: 'consignor'},
    {label: this.translate.instant('account.section.shipment.ongoing.table.header3'), value: 'consignee'},
    {label: this.translate.instant('account.section.shipment.ongoing.table.header4'), value: 'delivery_date'},
    {label: this.translate.instant('account.section.shipment.ongoing.table.header5'), value: 'price'},
  ];

  @Input() shipmentsState: any;
  @Input() data: any;
  @Input() currentPage: number;
  @Input() currentPageSize: number;
  @Input() totalShipmentsLength: number;

  @Output() onChangePage: EventEmitter<any> = new EventEmitter();
  constructor(
    private translate: TranslateService,
    public faService: FontAwesomeService,
    public router: Router,
  ) {}

  generateData(shipments = []) {
    return shipments.map((
        {consignor, consignee, amount, vat, shipment_ref, delivery_date, delivery_time_from, delivery_time_to, id, reference}) => {
        const startTime = delivery_time_from.length === 8 ? delivery_time_from.slice(0, -3) : delivery_time_from;
        const endTime = delivery_time_to.length === 8 ? delivery_time_to.slice(0, -3) : delivery_time_to;
        const timeString =  this.translate.instant('common.date.timeLabel') + ' ' + startTime + ' - ' + endTime;
      return {
        consignor: consignor &&
          `${consignor.country_code.toUpperCase()}-${consignor.zip}, ${consignor.city.toUpperCase()}`,
        consignee: consignee &&
          `${consignee.country_code.toUpperCase()}-${consignee.zip}, ${consignee.city.toUpperCase()}`,
        consignment_no: shipment_ref,
          price: `${(new CurrencyFormatPipe(this.translate)
              .transform(+amount, 'SEK', 'code', '1.2-2', this.translate.currentLang))}`,
          delivery_date: `${(new DateFormatPipe(this.translate)).transform(
              delivery_date, 'mediumDate', '', this.translate.currentLang)}`,
        id,
        reference
      };
    });
  }

  handleChangePage(current_page) {

    this.onChangePage.emit(current_page);
  }

  handleSelectRow(id) {
    this.router.navigate(
      ['/shipments/ongoing/', id]
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/ongoing-shipments/ongoing-shipments.component.ts